import { LuUserRound, LuPhone, LuClipboardList, LuPhoneIncoming } from 'react-icons/lu';
import { PiUsersThree } from 'react-icons/pi';
import { RiFolderUserLine } from 'react-icons/ri';
import { BsClipboardData } from 'react-icons/bs';
import { LiaFunnelDollarSolid, LiaUsersSolid } from 'react-icons/lia';
import { useAuthContext } from '@contexts/auth';

const LIST = [
  {
    label: 'Clientes',
    path: 'clientes',
    role: 'CAN_VIEW_CUSTOMERS',
    icon: <PiUsersThree size={24} />
  },
  {
    label: 'Portfólios',
    path: 'portfolios',
    role: 'CAN_READ_PORTFOLIO',
    icon: <RiFolderUserLine size={24} />
  },
  {
    label: 'Campanhas',
    path: 'campanhas',
    role: 'CAN_READ_CAMPAIGNS',
    icon: <BsClipboardData size={24} />
  },
  {
    label: 'Atendimentos',
    path: 'atendimentos',
    role: 'CAN_VIEW_CAMPAIGN_EXECUTION',
    icon: <LuPhone size={24} />
  },
  {
    label: 'Meus Atendimentos',
    path: 'meus-atendimentos',
    role: ['CAN_PERFORM_WALKIN', 'CAN_PERFORM_CAMPAIGN_EXECUTION'],
    icon: <LuPhoneIncoming size={24} />
  },
  {
    label: 'Opções de tabulação',
    path: 'opcoes-de-tabulacao',
    role: 'CAN_READ_TABULATION_OPTIONS',
    icon: <LuClipboardList size={24} />
  },
  {
    label: 'Funil de vendas',
    path: 'funil-de-vendas',
    role: 'CAN_READ_SALESFUNNELS',
    icon: <LiaFunnelDollarSolid size={24} />
  },
  {
    label: 'Usuários',
    path: 'usuarios',
    role: 'CAN_VIEW_USERS',
    icon: <LuUserRound size={24} />
  },
  {
    label: 'Equipes',
    path: 'equipes',
    role: 'CAN_READ_TEAMS',
    icon: <LiaUsersSolid size={24} />
  },
];

const useMenuList = () => {
  const { roles } = useAuthContext();

  const filteredMenu = LIST.filter((item) => (
    Array.isArray(item.role)
      ? item.role.some((role) => roles.includes(role))
      : roles.includes(item.role)
  ));

  return filteredMenu;
};

export default useMenuList;

